export enum VesselVisitStatusCodes {
    Announced = 'ANN',
    Arrived = 'ARR',
    Departed = 'DEP',
    Canceled = 'CAN',
    OnAnchorage = 'ANC',
    Preannounced = 'PRE'
}